import { ref, watch } from 'vue';

export function useFormValidation(fields, rules) {
  const errors = ref({});
  const isFormValid = ref(false);

  function validateForm() {
    errors.value = {};

    // Validate each field according to its rules
    for (const field in fields) {
      if (rules[field]) {
        const error = rules[field](fields[field]);
        if (error) {
          errors.value[field] = error;
        }
      }
    }

    // Check if the form is valid
    isFormValid.value = Object.keys(errors.value).length === 0;
  }

  // Watch for changes in field values and validate form
  watch(
    fields,  // Watch the fields directly
    () => validateForm(),
    { deep: true, immediate: true }
  );

  return { isFormValid, errors, validateForm };
}
